import {
  ke
} from "../../../chunks/chunk.WKUNRGJV.js";
import "../../../chunks/chunk.FAJKIEWS.js";
import "../../../chunks/chunk.2QRLEY22.js";

// src/components/jb-svg/icons/DOWNLOAD.svg.ts
var DOWNLOAD_svg_default = ke`<svg
  viewBox="0 0 1800 1800"
  xmlns="http://www.w3.org/2000/svg"
  fill="currentColor"
>
  <path
    d="M 230.841 965.421 C 230.841 929.288 201.553 900 165.421 900 C 129.288 900 100 929.288 100 965.421 V 1461.66 C 100.003 1588.94 203.556 1692.49 330.838 1692.49 H 1467.98 C 1595.26 1692.49 1698.82 1588.94 1698.82 1461.66 V 965.421 C 1698.82 929.288 1669.53 900 1633.4 900 C 1597.27 900 1567.98 929.288 1567.98 965.421 V 1461.66 C 1567.98 1516.79 1523.12 1561.65 1467.99 1561.65 H 330.835 C 275.698 1561.65 230.841 1516.79 230.841 1461.66 V 965.421 Z"
  />
  <path
    d="M 865.156 1169.61 C 888.436 1192.89 926.182 1192.89 949.464 1169.61 L 953.035 1166.04 L 1269.22 849.856 C 1292.5 826.574 1292.5 788.828 1269.22 765.547 C 1245.94 742.267 1208.19 742.265 1184.91 765.547 L 971.976 978.48 L 971.976 191.451 C 971.975 155.737 943.024 126.786 907.311 126.786 C 889.454 126.784 873.286 134.024 861.584 145.726 C 849.88 157.431 842.644 173.598 842.644 191.453 L 842.646 978.482 L 629.712 765.547 C 606.431 742.267 568.686 742.265 545.403 765.547 C 522.121 788.83 522.123 826.576 545.403 849.856 L 861.586 1166.04 L 865.156 1169.61 Z"
  />
</svg>`;
export {
  DOWNLOAD_svg_default as default
};
